export const AppVersion: string = '2.14.6';
export const BuildVersion: string = '117';
